module.exports = __webpack_public_path__ + "img/thanos-pc.6e09a177.png";